var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCode2Add(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13747_146127",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13747_146127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 14V12H7V14H5ZM3 12V10H5V12H3ZM12 5V3H14V5H12ZM4.5 7.5H7.5V4.5H4.5V7.5ZM3 9V3H9V9H3ZM4.5 19.5H7.5V16.5H4.5V19.5ZM3 21V15H9V21H3ZM16.5 7.5H19.5V4.5H16.5V7.5ZM15 9V3H21V9H15ZM9 14V12H7V10H11V14H9ZM10 9V5H12V7H14V9H10ZM5.25 6.75V5.25H6.75V6.75H5.25ZM5.25 18.75V17.25H6.75V18.75H5.25ZM17.25 6.75V5.25H18.75V6.75H17.25ZM16 21V18H13V16H16V13H18V16H21V18H18V21H16Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode2Add);
export default __webpack_public_path__ + "static/media/qr_code_2_add.d4a4461f.svg";
export { ForwardRef as ReactComponent };